import type { IVariablesData, IVariablesChangeData } from '../../WorkOrderUseCoefficient';

import { useWorkOrderChangeGridPickData } from './useWorkOrderChangeGridPickData';
import { useWorkOrderGridPickData } from './useWorkOrderGridPickData';

export const useGridPickCoefficientsData = (
    variablesChangeData: IVariablesChangeData,
    variablesData?: IVariablesData | undefined,
    isWorkOrderChange?: boolean,
) => {
    const { orderDatasource, orderFetchingStatus } = useWorkOrderGridPickData(variablesData);
    const { orderChangeDatasource, orderChangeFetchingStatus } = useWorkOrderChangeGridPickData(variablesChangeData);

    return {
        datasource: isWorkOrderChange ? orderChangeDatasource : orderDatasource,
        fetchingStatus: isWorkOrderChange ? orderChangeFetchingStatus : orderFetchingStatus,
    };
};
